export default __webpack_public_path__ + "static/media/Press_c.dfcec002.png";